import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { Approche } from "../components/Approche";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";

const HomePage = () => {
  const location = useLocation();

  // When landing on home with a hash (e.g. /#about coming from another route),
  // scroll smoothly to that section after mount.
  useEffect(() => {
    if (location.hash) {
      const target = document.querySelector(location.hash);
      if (target) {
        // Slight delay to ensure sections are laid out before scrolling
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 80);
      }
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [location.hash, location.key]);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Approche />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
